
export const getThumbnail = (thumbnails, width,height) => {
    let thumbnail = thumbnails.find(x => (x.width == width) && (x.height == height))
    return  thumbnail.ipfs_hash
}